import { RES_EN } from "./resourcesEN";
import { RES_AR } from "./resourcesAR";

export const RESOURCES = { en: RES_EN, ar: RES_AR };
